import React from "react";
import AccordionAreaChildren from "./AccordionAreaChildren";
import "./index.css";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import {
  GOVGR_ACCORDION__SECTION_BUTTON,
  GOVGR_ACCORDION__SECTION_BUTTON_NOICON,
  GOVGR_ACCORDION__SECTION_HEADING,
  GOVGR_ACCORDION__SECTION_NO_BORDER,
  GOVGR_ACCORDION__SECTION_SUMMARY,
} from "../../conf/styles/GovGrAccordion";

const AccordionSections = ({ table }) => {
  const location = useLocation();
  return (
    <>
      {table?.map((item, index) => {
        let detailsClass = classNames(GOVGR_ACCORDION__SECTION_NO_BORDER, {
          "bg-[#ebebeb]": location.pathname === item.path,
        });

        return (
          <details
            className={detailsClass}
            key={index}
            open={location.pathname.includes(item.path)}
          >
            <summary className={`${GOVGR_ACCORDION__SECTION_SUMMARY}`}>
              <h2 className={`${GOVGR_ACCORDION__SECTION_HEADING}`}>
                {!!item.children ? (
                  <span
                    className={`${GOVGR_ACCORDION__SECTION_BUTTON}`}
                    value={item.id}
                  >
                    {item.id}
                  </span>
                ) : (
                  <Link to={item.path}>
                    <span
                      className={`${GOVGR_ACCORDION__SECTION_BUTTON_NOICON}`}
                    >
                      {item.id}
                    </span>
                  </Link>
                )}
              </h2>
            </summary>
            {item.children && (
              <AccordionAreaChildren
                childrentable={item.children}
                locationname={location.pathname}
              />
            )}
          </details>
        );
      })}
    </>
  );
};

export default AccordionSections;
